// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"eeffcc87","542":"5af04796","591":"8cd07fdb","688":"08f81718","754":"64eaef80","788":"97e2fa5f","895":"cc0a0318","899":"577cf79f","922":"31282d17","925":"f48b149c","983":"5aeadbd8"}[chunkId] + ".chunk.js";
};